import { createModal } from "@commonlibs";
import clsx from "clsx";
import TabsModal from "ui/common/components/feedback/TabsModal/TabsModal";
import { TabsModalProps, ModalTab } from "ui/common/components/feedback/TabsModal/TabsModal.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import SetConversionRateTab from "./SetConversionRateTab";
import { UpdateConversionRateState } from "./UpdateConversionRateModal.types";
import ConfirmUpdateConversionRateTab from "./ConfirmUpdateConversionRateTab";

export interface UpdateConversionRateModalProps extends Omit<TabsModalProps<UpdateConversionRateState>, "tabs" | "title"> {
    className?: string;
    style?: React.CSSProperties;
}

const UPDATE_CONVERSION_RATE_TABS: ModalTab[] = [
    {
        content: <SetConversionRateTab />,
    },
    {
        content: <ConfirmUpdateConversionRateTab />,
    },
];

const UpdateConversionRateModal = createModal(({ className, ...rest }: UpdateConversionRateModalProps) => {
    const translate = useTranslate();

    return (
        <TabsModal
            title={translate("setConversionRate")}
            tabs={UPDATE_CONVERSION_RATE_TABS}
            className={clsx("update-conversion-rate-modal", className)}
            {...rest}
        />
    );
});

export default UpdateConversionRateModal;
